// extracted by mini-css-extract-plugin
export default {"container":"style_container__MSYBX","video":"style_video__kLAZM","videoFrame":"style_videoFrame__1A7WD"};